import { legacyPlugins } from "/app/node_modules/.pnpm/@unhead+vue@3.3.1_@oxc-project+types@0.142.0_esbuild@0.28.1_lightningcss@1.33.0_oxc-par_1fc6773bbc42157f13cf96033e0f035c/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}